

















import { Component, Mixins, Prop } from "vue-property-decorator";
import { ReceptionContactDetail } from "../../../../domain/workflow/reception";

@Component
export default class ReceptionContactDetailView extends Mixins() {
  @Prop()
  detail: ReceptionContactDetail;

  get isRequired(): string {
    return this.detail ? (this.detail.isRequired ? "要" : "不要") : "";
  }

  get contacts(): string {
    return this.detail ? this.detail.contacts : "";
  }

  get contactName(): string {
    return this.detail ? this.detail.contactName : "";
  }

  get contactNameText(): string {
    return this.contactName
      ? "（" + this.contactName + "）"
      : "";
  }

  get contactText(): string {
    return this.isRequired + this.contactNameText;
  }
}
